var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 34.25V39.875C37.5 41.4261 36.3787 42.6875 35 42.6875H5C3.62125 42.6875 2.5 41.4261 2.5 39.875V34.25C2.5 33.4737 3.06 32.8438 3.75 32.8438C4.44 32.8438 5 33.4737 5 34.25V39.875H35V34.25C35 33.4737 35.56 32.8438 36.25 32.8438C36.94 32.8438 37.5 33.4737 37.5 34.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3666 23.9942C9.87781 23.4444 9.87781 22.5556 10.3666 22.0058C10.8553 21.4559 11.6453 21.4559 12.1341 22.0058L18.7503 29.4491V4.71875C18.7503 3.9425 19.3103 3.3125 20.0003 3.3125C20.6903 3.3125 21.2503 3.9425 21.2503 4.71875V29.4491L27.8666 22.0058C28.3553 21.4559 29.1453 21.4559 29.6341 22.0058C30.1228 22.5556 30.1228 23.4444 29.6341 23.9942L20.8841 33.838C20.3891 34.3963 19.5953 34.378 19.1153 33.838L10.3666 23.9942Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/download_white.c7520128458249242e80929c8f7e5b3f.svg";
export { ForwardRef as ReactComponent };